import _get from 'lodash/get';
import _startCase from 'lodash/startCase';
import { BListGroup, BListGroupItem } from 'bootstrap-vue';

export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  render(el) {
    return el(BListGroup, { props: {} }, this.fields.map(({ key, label, formatter }) => {
      let value = _get(this.value, key) || null;
      if (typeof formatter === 'function') {
        value = formatter(value, key, this.value, el);
      }

      return el(BListGroupItem, {}, [ el('b', { class: 'd-block' }, [ label || _startCase(key) ]), value ]);
    }));
  },
};



// WEBPACK FOOTER //
// ./src/components/manage/SidebarDetails.js